var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"live-content"},[(_vm.classId)?_c('liveroom-module',{attrs:{"class-id":_vm.classId,"sub-id":_vm.subId,"is-replay":_vm.isReplay,"course-belong":'chiral',"track":() => {}},on:{"live-info":_vm.getLiveInfo}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }